/**
 * Custom hook for magnetic button effect
 * Creates a smooth follow-cursor effect on buttons
 * 
 * @param {number} strength - Movement strength multiplier (default: 0.2)
 * @param {number} scale - Scale on hover (default: 1.02)
 * @returns {object} - Event handlers for onMouseMove, onMouseLeave, and onMouseEnter
 */
export function useMagneticButton(strength = 0.2, scale = 1.02) {
  const handleMouseEnter = (e) => {
    const btn = e.currentTarget;
    // Add smooth transition
    btn.style.transition = 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)';
    btn.style.willChange = 'transform';
  };

  const handleMouseMove = (e) => {
    const btn = e.currentTarget;
    const rect = btn.getBoundingClientRect();
    const x = e.clientX - rect.left - rect.width / 2;
    const y = e.clientY - rect.top - rect.height / 2;
    // Remove transition for instant follow
    btn.style.transition = 'none';
    btn.style.transform = `translate(${x * strength}px, ${y * strength}px) scale(${scale})`;
  };

  const handleMouseLeave = (e) => {
    const btn = e.currentTarget;
    // Add transition back for smooth return
    btn.style.transition = 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)';
    btn.style.transform = 'translate(0, 0) scale(1)';
    // Clean up
    setTimeout(() => {
      btn.style.willChange = 'auto';
    }, 300);
  };

  return {
    onMouseEnter: handleMouseEnter,
    onMouseMove: handleMouseMove,
    onMouseLeave: handleMouseLeave,
  };
}
